import styled, { css } from 'styled-components';
import { colorGetter } from '../../../../utils';
import { Flex } from '../../../Flex';
export var Button = styled(Flex).withConfig({
  displayName: "styled__Button",
  componentId: "sc-19uc5bu-0"
})(["position:relative;width:48px;height:48px;justify-content:center;align-items:center;border-radius:50%;flex-shrink:0;cursor:pointer;pointer-events:", ";background-color:", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'none' : 'auto';
}, function (_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color,
      disabled = _ref2.disabled;
  return disabled ? theme.colors.grey.base : colorGetter(theme)(color);
});
export var Transition = styled(Flex).withConfig({
  displayName: "styled__Transition",
  componentId: "sc-19uc5bu-1"
})(["position:absolute;pointer-events:none;transition:all 0.7s;transform:", ";opacity:0;", ";"], function (_ref3) {
  var reverse = _ref3.reverse;
  return "rotate(" + (reverse ? 180 : -180) + "deg)";
}, function (_ref4) {
  var show = _ref4.show;
  return show && css(["transform:rotate(0);opacity:1;"]);
});